import React, { useState } from "react";
import * as Yup from "yup";
import { API } from "../../../../../shared/services";
import {
  Button,
  CardContent,
  FormControl,
  FormLabel,
  TextField,
} from "@material-ui/core";
import { ShoppingCartOutlined } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import { Formik } from "formik";
import moment from "moment";
import { ItemSpotlight } from "../Item";
import { Field } from "../Products/styles";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useContacts } from "../../../contexts";

function RegisterSoldProduct({ customer, setSpotlight }) {
  const { t } = useTranslation();
  const { setShowModal, updateCurrentContact } = useContacts();
  const { products } = customer;

  function handleSubmit(values) {
    API.post(`customers/${customer.id}/products/${values.product.id}/sold`, {
      sold_product: {
        message: values.message,
        created_at: values.date,
      },
    })
      .then((result) => {
        toast.success("Produto marcado como negócio fechado!");

        updateCurrentContact({
          ...customer,
          sold_products: [...(customer?.sold_products || []), result.data],
        });

        setShowModal("after_sold");
      })
      .catch(() => {
        toast.error(
          "Não foi possível marcar esse produto como negócio fechado"
        );
      });
  }

  return (
    <ItemSpotlight
      leftAction={<ShoppingCartOutlined />}
      title="Adicionar negócio como fechado"
    >
      <CardContent>
        <Formik
          initialValues={{ product: [], date: new Date(), message: "" }}
          validationSchema={Yup.object({
            date: Yup.date(t("common:errors.invalid"))
              .required(t("common:errors.required"))
              .nullable(),
            product: Yup.mixed(t("common:errors.invalid"))
              .required(t("common:errors.required"))
              .nullable(),
          })}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange, errors, handleSubmit, setFieldValue }) => (
            <form>
              <FormControl component="fieldset" variant="outlined" fullWidth>
                <FormLabel component="legend" style={{ marginBottom: 10 }}>
                  Selecionar produto
                </FormLabel>

                <Autocomplete
                  id="product"
                  options={products}
                  getOptionLabel={(product) => {
                    const reference_code = product.reference_code
                      ? `[${product.reference_code}] `
                      : "";

                    return (
                      reference_code +
                      (product.name || t("details.products.withoutName"))
                    );
                  }}
                  getOptionSelected={(option, value) => option.id === value.id}
                  onChange={(_event, product) =>
                    setFieldValue("product", product)
                  }
                  renderInput={(params) => (
                    <Field
                      {...params}
                      label="Produto"
                      variant="outlined"
                      helperText={errors.product}
                    />
                  )}
                />
              </FormControl>

              <FormControl
                component="fieldset"
                variant="outlined"
                fullWidth
                style={{ marginBottom: 30 }}
              >
                <FormLabel component="legend" style={{ marginBottom: 10 }}>
                  Data
                </FormLabel>

                <TextField
                  name="date"
                  variant="outlined"
                  type="date"
                  value={values.date}
                  InputProps={{
                    inputProps: { max: moment().format("YYYY-MM-DD") },
                  }}
                  onChange={handleChange}
                  className="current-activity-sidebar___input"
                  format="DD/MM/YYYY"
                  helperText={errors.date}
                />
              </FormControl>

              <FormControl
                component="fieldset"
                variant="outlined"
                fullWidth
                style={{ marginBottom: 30 }}
              >
                <FormLabel component="legend" style={{ marginBottom: 10 }}>
                  Observações
                </FormLabel>

                <TextField
                  variant="outlined"
                  fullWidth
                  rows="5"
                  name="message"
                  type="textarea"
                  value={values.message}
                  onChange={handleChange}
                />
              </FormControl>

              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={handleSubmit}
              >
                Registrar negócio fechado
              </Button>
            </form>
          )}
        </Formik>
      </CardContent>
    </ItemSpotlight>
  );
}

export default RegisterSoldProduct;
